const cards = [
  {
    title: '《流浪地球3》前传特辑',
    tag: '科幻',
    desc: '深度解析流浪地球宇宙的世界观设定与隐藏彩蛋，带你看懂中国科幻电影的宏大叙事。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20space%20structures%20and%20warm%20atmospheric%20lighting%2C%20dramatic%20scale%2C%20futuristic%20aesthetic%2C%20rich%20golden%20and%20dark%20tones&width=800&height=600&seq=card-01-97movie&orientation=landscape',
  },
  {
    title: '2026年必看华语电影清单',
    tag: '片单',
    desc: '年度精选华语电影推荐，涵盖剧情、喜剧、悬疑等多种类型，收藏这一份就够了。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20elegant%20composition%20with%20warm%20theater%20lighting%2C%20red%20and%20gold%20aesthetic%2C%20film%20poster%20collage%20style%2C%20artistic%20cinematic%20mood&width=800&height=600&seq=card-02-97movie&orientation=landscape',
  },
  {
    title: '豆瓣9分以上神剧盘点',
    tag: '高分',
    desc: '那些口碑炸裂的神级剧集，每一部都值得反复品味，看看你错过了哪些宝藏。',
    img: 'https://readdy.ai/api/search-image?query=Award%20winning%20film%20atmosphere%20with%20warm%20golden%20highlights%2C%20cinematic%20depth%2C%20elegant%20movie%20poster%20aesthetic%2C%20dramatic%20lighting%2C%20premium%20quality%20feel&width=800&height=600&seq=card-03-97movie&orientation=landscape',
  },
  {
    title: '周星驰喜剧全集回顾',
    tag: '经典',
    desc: '从《大话西游》到《功夫》，重温星爷那些笑中带泪的经典瞬间，每一部都是回忆。',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20comedy%20cinema%20nostalgic%20style%20with%20warm%20vintage%20tones%2C%20classic%20film%20aesthetic%2C%20golden%20age%20movie%20atmosphere%2C%20retro%20cinematic&width=800&height=600&seq=card-04-97movie&orientation=landscape',
  },
  {
    title: '悬疑剧迷必看烧脑合集',
    tag: '悬疑',
    desc: '层层反转烧脑不停，精选国内外高分悬疑剧，挑战你的推理能力。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20dark%20moody%20shadows%20and%20warm%20accent%20lighting%2C%20film%20noir%20style%2C%20suspenseful%20atmosphere%2C%20dramatic%20contrast&width=800&height=600&seq=card-05-97movie&orientation=landscape',
  },
  {
    title: '国漫精品推荐专题',
    tag: '动漫',
    desc: '国漫崛起之作精选，从神话改编到原创故事，每一部都展现了中国动画的无限可能。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20with%20warm%20golden%20and%20crimson%20tones%2C%20traditional%20ink%20wash%20elements%2C%20modern%20animation%20style%2C%20ethereal%20atmospheric%20lighting&width=800&height=600&seq=card-06-97movie&orientation=landscape',
  },
  {
    title: '暑期亲子观影指南',
    tag: '亲子',
    desc: '适合全家一起观看的高分电影推荐，寓教于乐，陪伴孩子度过一个充实的影视假期。',
    img: 'https://readdy.ai/api/search-image?query=Family%20friendly%20cinema%20atmosphere%20with%20warm%20golden%20lighting%2C%20animated%20film%20aesthetic%2C%20soft%20and%20inviting%20mood%2C%20colorful%20yet%20elegant%20cinematic%20feel&width=800&height=600&seq=card-07-97movie&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑精选的优质影视内容，每一篇都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500 text-white rounded-md">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
          <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer sm:col-span-2 lg:col-span-3">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-1/3 aspect-[4/3] sm:aspect-auto overflow-hidden">
                <img
                  src={cards[6].img}
                  alt={cards[6].title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="px-2.5 py-1 text-xs font-medium bg-secondary-500 text-white rounded-md self-start mb-3">
                  {cards[6].tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {cards[6].title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {cards[6].desc}
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}